class SizeGuideDrawer extends HTMLElement {
  constructor() {
    super();

    this.lastFocusedElement = null;

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
    document.addEventListener("click", this.handleDocumentClick);

    document.removeEventListener("keydown", this.handleKeydown);
    document.addEventListener("keydown", this.handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("keydown", this.handleKeydown);
  }

  handleDocumentClick(event) {
    /*
     * ドロワーを開く
     */
    const openButton = event.target.closest("[data-size-guide-open]");

    if (openButton) {
      const targetId = openButton.dataset.sizeGuideTarget;

      if (targetId === this.id) {
        event.preventDefault();

        const contentName =
          openButton.dataset.sizeGuideOpen || "sizeguide";

        this.open(openButton, contentName);
      }

      return;
    }

    /*
     * ドロワー内のタブ切り替え
     */
    const tabButton = event.target.closest("[data-size-guide-title]");

    if (tabButton && this.contains(tabButton)) {
      event.preventDefault();

      const contentName = tabButton.dataset.sizeGuideTitle;

      this.setActiveContent(contentName);
      return;
    }

    /*
     * ドロワーを閉じる
     */
    const closeButton = event.target.closest("[data-size-guide-close]");

    if (closeButton && this.contains(closeButton)) {
      event.preventDefault();
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key !== "Escape") return;
    if (!this.classList.contains("is-open")) return;

    this.close();
  }

  setActiveContent(contentName) {
    const titles = this.querySelectorAll(
      "[data-size-guide-title]"
    );

    const sections = this.querySelectorAll(
      "[data-size-guide-content]"
    );

    /*
     * タイトル切り替え
     */
    titles.forEach((title) => {
      const isActive =
        title.dataset.sizeGuideTitle === contentName;

      title.classList.toggle("is-active", isActive);

      title.setAttribute(
        "aria-selected",
        isActive ? "true" : "false"
      );

      title.setAttribute(
        "tabindex",
        isActive ? "0" : "-1"
      );
    });

    /*
     * セクション切り替え
     */
    sections.forEach((section) => {
      const isActive =
        section.dataset.sizeGuideContent === contentName;

      section.classList.toggle("is-active", isActive);

      section.setAttribute(
        "aria-hidden",
        isActive ? "false" : "true"
      );
    });
  }

  open(triggerButton, contentName = "sizeguide") {
    this.lastFocusedElement = triggerButton;

    /*
    * 開いたボタンに対応する内容を表示
    */
    this.setActiveContent(contentName);

    this.classList.add("is-open");
    this.setAttribute("aria-hidden", "false");

    document.body.classList.add("overflow-hidden");

    /*
    * ヘッダーを上へ退避
    */
    document.documentElement.classList.add("is-size-guide-open");

    document
      .querySelectorAll(
        `[data-size-guide-target="${this.id}"]`
      )
      .forEach((button) => {
        const isCurrentButton = button === triggerButton;

        button.setAttribute(
          "aria-expanded",
          isCurrentButton ? "true" : "false"
        );
      });

    const closeButton = this.querySelector(
      ".size-guide-drawer__close"
    );

    if (closeButton) {
      closeButton.focus();
    }
  }

  close() {
    this.classList.remove("is-open");
    this.setAttribute("aria-hidden", "true");

    document.body.classList.remove("overflow-hidden");

    /*
    * ヘッダーを元に戻す
    */
    document.documentElement.classList.remove("is-size-guide-open");

    document
      .querySelectorAll(
        `[data-size-guide-target="${this.id}"]`
      )
      .forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });

    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus();
    }

    this.lastFocusedElement = null;
  }
}

if (!customElements.get("size-guide-drawer")) {
  customElements.define("size-guide-drawer", SizeGuideDrawer);
}